import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import AdminService from "../../../../services/AdminService";
import { Translate } from "../../../Enums/Tranlate";
import { useLocation, useNavigate } from "react-router-dom";
import CountryService from "../../../../services/CountryService";
import ZoneService from "../../../../services/ZoneService";

const AddZones = () => {
	const location = useLocation();
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		price_per: "hour",
		price: "",
		events_schedule: "",
		event_start_date: "",
		event_end_date: "",
		event_start_time: "",
		event_end_time: "",
		alert_time: "",
		government: "",
		area: "",
		block: "",
		street: "",
		location: "",
		floor: "",
		number_of_available_parking: "",
		assigned_staff: [],
		temporary_zone: false,
		start_date: "",
		end_date: "",
		quick_valet_price: "",
	});
	const navigate = useNavigate();
	const [governmentsOptions, setGovernmentsOptions] = useState([]);
	const [areasOptions, setAreasOptions] = useState([]);
	const [isAdd, setIsAdd] = useState(false);
	const [assignedStaffOptions, setAssignedStaffOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const adminService = new AdminService();
	const countryService = new CountryService();
	const zoneService = new ZoneService();

	useEffect(() => {
		countryService.getList().then((res) => {
			if (res?.status === 200) {
				console.log(res, res?.data, res?.data?.data);
				let data = res?.data?.data?.data?.map((info) => {
					return {
						label: lang === "en" ? info?.name_en : info?.name_ar,
						value: info?.id,
					};
				});
				setGovernmentsOptions(data);
			}
		});
	}, [lang]);

	useEffect(() => {
		if (!location?.state) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			let state = location?.state;
			setFormData({
				id: state?.id,
				name_en: state?.name_en,
				name_ar: state?.name_ar,
				price_per: state?.price_per,
				price: state?.price,
				quick_valet_price: state?.quick_valet_price || "",
				events_schedule: state?.events_schedule || "",
				event_start_date: state?.event_start_date?.split("T")[0],
				event_end_date: state?.event_end_date?.split("T")[0],
				event_start_time: state?.event_start_time,
				event_end_time: state?.event_end_time,
				alert_time: state?.alert_time,
				government: {
					label:
						lang === "en"
							? state?.governorate?.name_en
							: state?.governorate?.name_ar,
					value: state?.governorate_id,
				},
				area: {
					label: lang === "en" ? state?.area?.name_en : state?.area?.name_ar,
					value: state?.area_id,
				},
				block: state?.block,
				street: state?.street,
				location: state?.location,
				floor: state?.floor || "",
				number_of_available_parking: state?.number_of_available_parking || "",
				assigned_staff: state?.admin_zones?.map((res) => {
					return {
						...res?.user,
						label: res?.user?.username,
						value: res?.user_id,
					};
				}),
				temporary_zone: state?.temporary_zone,
				start_date: !!state?.start_date ? state?.start_date?.split("T")[0] : "",
				end_date: !!state?.end_date ? state?.end_date?.split("T")[0] : "",
			});
		}
		adminService.getList().then((res) => {
			if (res?.status === 200) {
				let data = res?.data?.data?.data?.map((info) => {
					return {
						label: info?.username,
						value: info?.id,
					};
				});
				setAssignedStaffOptions(data);
			}
		});
	}, []);

	useEffect(() => {
		if (!!formData?.government?.value) {
			countryService.getArea(formData?.government?.value).then((res) => {
				if (res?.status === 200) {
					let data = res?.data?.data?.map((info) => {
						return {
							label: lang === "en" ? info?.name_en : info?.name_ar,
							value: info?.id,
						};
					});
					setAreasOptions(data);
				}
			});
		}
	}, [formData?.government, lang]);

	const submit = (e) => {
		e.preventDefault();
		if (
			!formData?.government ||
			!formData?.area ||
			!formData?.assigned_staff?.length
		) {
			if (!formData?.government)
				toast.error(`${Translate[lang].select} ${Translate[lang].government}`);
			if (!formData?.area)
				toast.error(`${Translate[lang].select} ${Translate[lang].area}`);
			if (!formData?.assigned_staff?.length)
				toast.error(
					`${Translate[lang].select} ${Translate[lang].assigned_staff}`,
				);

			return;
		}
		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			price_per: formData?.price_per,
			price: formData?.price,
			governorate_id: formData?.government?.value,
			area_id: formData?.area?.value,
			temporary_zone: formData?.temporary_zone,
			user_id: formData?.assigned_staff?.map((res) => res?.value),
		};
		if (formData?.price_per === "events_schedule") {
			data["event_start_date"] = formData?.event_start_date;
			data["event_end_date"] = formData?.event_end_date;
			data["event_start_time"] = formData?.event_start_time;
			data["event_end_time"] = formData?.event_end_time;
			data["alert_time"] = formData?.alert_time;
		}
		if (formData?.events_schedule)
			data["events_schedule"] = formData?.events_schedule;
		if (formData?.quick_valet_price)
			data["quick_valet_price"] = formData?.quick_valet_price;
		if (formData?.temporary_zone) data["start_date"] = formData?.start_date;
		if (formData?.temporary_zone) data["end_date"] = formData?.end_date;
		if (formData?.block) data["block"] = formData?.block;
		if (formData?.street) data["street"] = formData?.street;
		if (formData?.location) data["location"] = formData?.location;
		if (formData?.floor) data["floor"] = formData?.floor;
		if (formData?.number_of_available_parking)
			data["number_of_available_parking"] = Number(
				formData?.number_of_available_parking,
			);

		setLoading(true);
		if (isAdd) {
			zoneService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						navigate("/zones");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			zoneService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						navigate("/zones");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<div>
			<div
				className="d-flex align-items-center"
				style={{ gap: "8px", margin: "12px 0 32px" }}>
				<svg
					style={{ cursor: "pointer" }}
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					onClick={() => navigate("/zones")}>
					<path
						d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.4999 12H3.66992"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>

				<label className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
					{!isAdd ? Translate[lang]?.edit : Translate[lang]?.add}{" "}
					{Translate[lang]?.zone}
				</label>

				{/* <Form.Check
					type="switch"
					id="custom-switch"
					checked={formData?.isActive}
					onChange={(e) =>
						setFormData({ ...formData, isActive: e.target.checked })
					}
				/> */}
			</div>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Row>
					{/* Name En */}
					<Col md={6}>
						<label className="text-label">
							{Translate[lang]?.name} ({Translate[lang]?.english})
							<span className="star-require">*</span>
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.name}
							bsSize="lg"
							name="name_en"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.name_en}
							onChange={(e) =>
								setFormData({
									...formData,
									name_en: e.target.value,
								})
							}
						/>
					</Col>
					{/* Name Ar */}
					<Col md={6}>
						<label className="text-label">
							{Translate[lang]?.name} ({Translate[lang]?.arabic})
							<span className="star-require">*</span>
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.name}
							bsSize="lg"
							name="name_ar"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.name_ar}
							onChange={(e) =>
								setFormData({
									...formData,
									name_ar: e.target.value,
								})
							}
						/>
					</Col>
					{/* Price Per */}
					<Col md={12} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.price_per}
							<span className="star-require">*</span>
						</label>
						<div className="d-flex gap-16">
							<label className="mb-0">
								<input
									type="radio"
									name="price_per"
									value="hour"
									checked={formData?.price_per === "hour"}
									onChange={() =>
										setFormData({
											...formData,
											price_per: "hour",
											events_schedule: "",
										})
									}
								/>{" "}
								{Translate[lang]?.hour}
							</label>
							<label className="mb-0">
								<input
									type="radio"
									name="price_per"
									value="day"
									checked={formData?.price_per === "day"}
									onChange={() =>
										setFormData({
											...formData,
											price_per: "day",
											events_schedule: "",
										})
									}
								/>{" "}
								{Translate[lang]?.day}
							</label>
							<label className="mb-0">
								<input
									type="radio"
									name="price_per"
									value="events_schedule"
									checked={formData?.price_per === "events_schedule"}
									onChange={() =>
										setFormData({
											...formData,
											price_per: "events_schedule",
											events_schedule: "",
										})
									}
								/>{" "}
								{Translate[lang]?.events_schedule}
							</label>
						</div>
					</Col>
					{formData?.price_per === "events_schedule" && (
						<Col md={12} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.events_schedule}
								<span className="star-require">*</span>
							</label>
							<div className="d-flex gap-16">
								<label className="mb-0">
									<input
										type="radio"
										name="events_schedule"
										value="weddings"
										checked={formData?.events_schedule === "weddings"}
										onChange={() =>
											setFormData({ ...formData, events_schedule: "weddings" })
										}
									/>{" "}
									{Translate[lang]?.weddings}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="events_schedule"
										value="private_events"
										checked={formData?.events_schedule === "private_events"}
										onChange={() =>
											setFormData({
												...formData,
												events_schedule: "private_events",
											})
										}
									/>{" "}
									{Translate[lang]?.private_events}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="events_schedule"
										value="seasonal_events"
										checked={formData?.events_schedule === "seasonal_events"}
										onChange={() =>
											setFormData({
												...formData,
												events_schedule: "seasonal_events",
											})
										}
									/>{" "}
									{Translate[lang]?.seasonal_events}
								</label>
							</div>
						</Col>
					)}
					{/* Price */}
					<Col md={6}>
						<label>
							{Translate[lang]?.price}
							<span className="star-require">*</span>
						</label>
						<AvField
							type="number"
							placeholder={Translate[lang]?.price}
							bsSize="lg"
							name="price"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.price}
							onChange={(e) =>
								setFormData({
									...formData,
									price: e.target.value,
								})
							}
						/>
					</Col>
					<Col md={6}>
						<label>
							{Translate[lang]?.quick_valet_price}
							{/* <span className="star-require">*</span> */}
						</label>
						<AvField
							type="number"
							placeholder={Translate[lang]?.quick_valet_price}
							bsSize="lg"
							name="quick_valet_price"
							// validate={{
							// 	required: {
							// 		value: true,
							// 		errorMessage: Translate[lang].field_required,
							// 	},
							// }}
							value={formData.quick_valet_price}
							onChange={(e) =>
								setFormData({
									...formData,
									quick_valet_price: e.target.value,
								})
							}
						/>
					</Col>
				</Row>
				{formData?.price_per === "events_schedule" && (
					<Row
						className="py-3 mb-3 mx-1"
						style={{ boxShadow: "0 0 4px #dedede", borderRadius: "8px" }}>
						{/* Event Start Date */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.event_start_date}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="date"
								placeholder={Translate[lang]?.event_start_date}
								bsSize="lg"
								min={isAdd ? new Date().toISOString().split("T")[0] : ""}
								name="event_start_date"
								value={formData.event_start_date}
								onChange={(e) =>
									setFormData({
										...formData,
										event_start_date: e.target.value,
									})
								}
							/>
						</Col>
						{/* Event End Date */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.event_end_date}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="date"
								placeholder={Translate[lang]?.event_end_date}
								bsSize="lg"
								min={
									formData?.event_start_date ||
									new Date().toISOString().split("T")[0]
								}
								name="event_end_date"
								value={formData.event_end_date}
								onChange={(e) =>
									setFormData({
										...formData,
										event_end_date: e.target.value,
									})
								}
							/>
						</Col>
						{/* Event Start Time */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.event_start_time}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="time"
								placeholder={Translate[lang]?.event_start_time}
								bsSize="lg"
								name="event_start_time"
								value={formData.event_start_time}
								onChange={(e) =>
									setFormData({
										...formData,
										event_start_time: e.target.value,
									})
								}
							/>
						</Col>
						{/* Event End Time */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.event_end_time}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="time"
								placeholder={Translate[lang]?.event_end_time}
								bsSize="lg"
								name="event_end_time"
								value={formData.event_end_time}
								onChange={(e) =>
									setFormData({
										...formData,
										event_end_time: e.target.value,
									})
								}
							/>
						</Col>
						{/* Alert Time */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.alert_time}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="time"
								placeholder={Translate[lang]?.alert_time}
								bsSize="lg"
								name="alert_time"
								value={formData.alert_time}
								onChange={(e) =>
									setFormData({
										...formData,
										alert_time: e.target.value,
									})
								}
							/>
						</Col>
					</Row>
				)}
				<hr />
				<Row>
					<Col md={12}>
						<label className="fs-16" style={{ color: "#7B7B7B" }}>
							{Translate[lang]?.full_address}
						</label>
					</Col>
					{/* Government */}
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.government}
							<span className="star-require">*</span>
						</label>
						<Select
							value={formData?.government}
							name="government"
							placeholder={Translate[lang]?.select}
							options={governmentsOptions}
							onChange={(e) => setFormData({ ...formData, government: e })}
						/>
					</Col>
					{/* Area */}
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.area}
							<span className="star-require">*</span>
						</label>
						<Select
							value={formData?.area}
							name="area"
							placeholder={Translate[lang]?.select}
							options={areasOptions}
							onChange={(e) => setFormData({ ...formData, area: e })}
						/>
					</Col>
					{/* block */}
					<Col md={6}>
						<label>
							{Translate[lang]?.block}
							<span className="star-require">*</span>
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.block}
							bsSize="lg"
							name="block"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.block}
							onChange={(e) =>
								setFormData({
									...formData,
									block: e.target.value,
								})
							}
						/>
					</Col>
					{/* street */}
					<Col md={6}>
						<label>
							{Translate[lang]?.street}
							<span className="star-require">*</span>
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.street}
							bsSize="lg"
							name="street"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.street}
							onChange={(e) =>
								setFormData({
									...formData,
									street: e.target.value,
								})
							}
						/>
					</Col>
					{/* location */}
					<Col md={6}>
						<label>
							{Translate[lang]?.location}
							<span className="star-require">*</span>
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.location}
							bsSize="lg"
							name="location"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.location}
							onChange={(e) =>
								setFormData({
									...formData,
									location: e.target.value,
								})
							}
						/>
					</Col>
					{/* floor */}
					<Col md={6}>
						<label>{Translate[lang]?.floor}</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.floor}
							bsSize="lg"
							name="floor"
							value={formData.floor}
							onChange={(e) =>
								setFormData({
									...formData,
									floor: e.target.value,
								})
							}
						/>
					</Col>
					{/* Assigned Staff */}
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.assigned_staff}
							<span className="star-require">*</span>
							<span className="mx-2" style={{ color: "#7B7B7B" }}>
								({Translate[lang]?.multi})
							</span>
						</label>
						<Select
							value={formData?.assigned_staff}
							name="assigned_staff"
							isMulti
							placeholder={Translate[lang]?.select}
							options={assignedStaffOptions}
							onChange={(e) => setFormData({ ...formData, assigned_staff: e })}
						/>
					</Col>
					{/* number_of_available_parking */}
					<Col md={6}>
						<label>
							{Translate[lang]?.number_of_available_parking}
							<span className="star-require">*</span>
						</label>
						<AvField
							type="number"
							placeholder={Translate[lang]?.number_of_available_parking}
							bsSize="lg"
							name="number_of_available_parking"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.number_of_available_parking}
							onChange={(e) =>
								setFormData({
									...formData,
									number_of_available_parking: e.target.value,
								})
							}
						/>
					</Col>
					<Col md={12}>
						<hr />
					</Col>
					<Col md={12} className="mb-3">
						<label className="mb-0">
							<input
								type="checkbox"
								name="temporary_zone"
								checked={formData?.temporary_zone}
								onChange={(e) => {
									setFormData({
										...formData,
										temporary_zone: e.target?.checked,
									});
								}}
							/>{" "}
							{Translate[lang]?.temporary_zone}
						</label>
					</Col>
					{/* Start Time */}
					{formData?.temporary_zone && (
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.start_date}
							</label>
							<AvField
								type="date"
								placeholder={Translate[lang]?.start_date}
								bsSize="lg"
								name="start_date"
								value={formData.start_date}
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								onChange={(e) =>
									setFormData({
										...formData,
										start_date: e.target.value,
									})
								}
							/>
						</Col>
					)}
					{/* End Time */}
					{formData?.temporary_zone && (
						<Col md={6}>
							<label className="text-label">{Translate[lang]?.end_date}</label>
							<AvField
								type="date"
								placeholder={Translate[lang]?.end_date}
								bsSize="lg"
								name="end_date"
								value={formData.end_date}
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								onChange={(e) =>
									setFormData({
										...formData,
										end_date: e.target.value,
									})
								}
							/>
						</Col>
					)}
					<Col md={6} className="mt-3 mb-5">
						<Button
							variant="primary"
							type="submit"
							className="w-100"
							disabled={loading}>
							{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
							{Translate[lang]?.zone}
						</Button>
					</Col>
				</Row>
			</AvForm>
		</div>
	);
};

export default AddZones;
